import React from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";

const CustomDropdown = ({
  label,
  value,
  onChange,
  options = [],
  name,
  required = false,
  fullWidth = true,
  disabled = false,
  error = false,
  helperText = "",
  className = "",
  size = "medium",
  showLabel = true,
  displayEmpty = false,
  ...otherProps
}) => {
  const labelId = `dropdown-label-${name || label || "select"}`;
  const useFloatingLabel = showLabel && Boolean(label);

  const handleChange = (e) => {
    if (onChange) {
      // If onChange expects an event object (like form handlers), pass the event
      if (name) {
        // Create a synthetic event-like object for form handlers
        const syntheticEvent = {
          target: {
            name: name,
            value: e.target.value,
          },
        };
        onChange(syntheticEvent);
      } else {
        // If no name, just pass the value directly
        onChange(e.target.value);
      }
    }
  };

  return (
    <FormControl
      fullWidth={fullWidth}
      error={error}
      disabled={disabled}
      className={className}
      required={required}
      size={size}
      {...otherProps}
    >
      {useFloatingLabel && <InputLabel id={labelId}>{label}</InputLabel>}
      <Select
        labelId={useFloatingLabel ? labelId : undefined}
        value={value || ""}
        label={useFloatingLabel ? label : undefined}
        onChange={handleChange}
        name={name}
        size={size}
        displayEmpty={displayEmpty || !useFloatingLabel}
        notched={useFloatingLabel ? undefined : false}
        MenuProps={{
          sx: {
            zIndex: 9999,
          },
        }}
        sx={
          !useFloatingLabel
            ? {
                "& .MuiOutlinedInput-notchedOutline legend": {
                  display: "none",
                  width: 0,
                },
              }
            : undefined
        }
        renderValue={(selected) => {
          if (selected === "" || selected === null || selected === undefined) {
            const placeholder = options.find((o) => o.value === "")?.label;
            return (
              <span style={{ color: "#98a39d" }}>
                {placeholder || (useFloatingLabel ? "" : "Select...")}
              </span>
            );
          }
          const match = options.find((o) => o.value === selected);
          return match?.label || selected;
        }}
      >
        {options.map((option, index) => (
          <MenuItem key={`${option.value}-${index}`} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {error && helperText && (
        <div style={{ color: "red", fontSize: "0.75rem", marginTop: "4px" }}>
          {helperText}
        </div>
      )}
    </FormControl>
  );
};

export default CustomDropdown;
